import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { ADMIN_MANY_ORDERS_API_PATHS } from '../constants/orders-api-paths.constant';
import HttpClient from '../../shared/infrastructures/clients/http.client';
import pluralFormatter from '../../shared/utils/plural-formater';
import type { LabelsData } from './get-labels-by-date.hook';

interface ArchiveOrdersResponse {
  archivedCount: number;
  labels?: LabelsData;
}

export function useArchiveOrders() {
  const { enqueueSnackbar } = useSnackbar();
  const [archiving, setArchiving] = useState(false);

  const archiveOrders = async (
    date: string,
    ownerRole?: string,
    generateLabels = true,
  ): Promise<ArchiveOrdersResponse | null> => {
    setArchiving(true);
    try {
      const response = await HttpClient.patch<ArchiveOrdersResponse>(ADMIN_MANY_ORDERS_API_PATHS.ARCHIVE, {
        date,
        ownerRole: ownerRole !== 'all' ? ownerRole : undefined,
        generateLabels,
      });
      enqueueSnackbar(
        pluralFormatter({
          count: response.archivedCount,
          singular: `${response.archivedCount} commande archivée`,
          plural: `${response.archivedCount} commandes archivées`,
        }),
        {
          variant: 'success',
        }
      );
      setArchiving(false);
      return response;
    } catch (error) {
      const message = error.response?.data?.message ?? `Une erreur est survenue lors de l'archivage`;
      enqueueSnackbar(message, { variant: 'error' });
      setArchiving(false);
      return null;
    }
  };

  return { archiving, archiveOrders };
}
